import React, {
  createContext, useContext, useState, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import api from 'services/api';
import { getUrl } from 'urlConfig';

const SchoolContext = createContext();

export const useSchool = () => {
  const context = useContext(SchoolContext);
  if (!context) {
    throw new Error('useSchool must be used within a SchoolProvider');
  }
  return context;
};

export const SchoolProvider = ({ children, id }) => {
  const [schoolData, setSchoolData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSchoolData = async () => {
      try {
        setIsLoading(true);
        const apiUrl = getUrl('api');
        const userData = JSON.parse(localStorage.getItem('vacanted'));
        const config = {
          url: `${apiUrl}/school/${id}?complete`,
          headers: userData?.token ? { authorization: userData.token } : {},
        };

        const response = await api.get(`${config.url}`, { headers: config.headers });
        setSchoolData(response.data);
        setError(null);
      } catch (err) {
        setError(err);
        console.error('Error fetching school data:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchoolData();
  }, [id]);

  const value = {
    schoolData,
    isLoading,
    error,
  };

  return (
    <SchoolContext.Provider value={value}>
      {children}
    </SchoolContext.Provider>
  );
};

SchoolProvider.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
};
